module.exports = __webpack_public_path__ + "static/media/home-bck-arw.34acd6b2.svg";